import React from 'react';
import { Switch } from '../../components';
import InputWrapper from '../InputWrapper/InputWrapper';
import { Props } from './SwitchField.types';

const SwitchField: React.FC<Props> = ({
  field,
  form,
  title,
  subtitle,
  extraContent = [],
  options,
  onChange,
  selected,
}) => {
  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <Switch name={field.name} options={options} onChange={onChange} selected={selected} />
    </InputWrapper>
  );
};

export default SwitchField;
